<template>
	<div class="box-collection">
		<Notification ref="notif" :closed="true" corner="bottom-right" style="color:#061529;"/>
		<div class="area_title">
			<div class="text">minhas coleções</div>
			<div class="select-status">
				<span class="txt-status">Status:</span>
				<div class="select">
					<select name="status" placeholder="Todas" v-model="status" @change="aplicarFiltro()">
						<option value="">Todas</option>
						<option value="Finalizado">Enviado e finalizados</option>
						<option value="Enviado">Enviado e pendente</option>
						<option value="Rascunho">Rascunho</option>
						<option value="Cancelado">Cancelado</option>
					</select>
					<i class="fas fa-chevron-down" ></i>
				</div>
			</div>
		</div>
		<hr>
		<div class="top_actions">
			<button @click="cadastro">
				<span class="fas fa-folder-plus"></span>
				<span> Criar Coleção</span>
			</button>
			<div class="txt-total-itens">Você possui {{ totalItens }} coleções </div>
		</div>
		<div v-if="!isLoad">
			<div class= "collection" v-for="lc in filteredCollections" :key="lc.id">
				<router-link :to="{ name: 'visualizarColecao', query: { id: lc.id }}">
					<div class="icon">
						<span class="fas fa-folder"></span>
					</div>
				</router-link>
				<router-link :to="{ name: 'visualizarColecao', query: { id: lc.id }}">
					<div class="collection_name">
						{{ lc.nome }}
					</div>
				</router-link>
				<div class="number">
					<div class="send" v-if="lc.status === 'Enviado'"> N° <span class="box-number">{{ lc.numero }}</span> </div>
					<div class="final" v-if="lc.status === 'Finalizado'"> N° <span class="box-number-final">{{ lc.numero }}</span> </div>
				</div>
				<div class="icon-status">
					<span v-if="lc.status === 'Enviado'" class="fas fa-hourglass-half hourglass"></span>
					<span v-if="lc.status === 'Finalizado'" class="fas fa-check-circle check"></span>
				</div>
				<div class="last_update" :class="{ 'env': lc.status === 'Enviado', 'fin': lc.status === 'Finalizado', 'rasc': lc.status === 'Rascunho'}">
					<span v-if="lc.status === 'Rascunho'" class="content_title">Atualizado em: </span>
					<span v-if="lc.status === 'Enviado'" class="content_title env">Solicitado em: </span>
					<span v-if="lc.status === 'Finalizado'" class="content_title fin">Finalizado em: </span>
					<span class="content">{{ lc.dtUpdate }}</span>
				</div>
				<div class="actions">
					<div class="button" @click="editCollection(lc.id)" :class="{ 'eye': lc.status === 'Enviado' || lc.status === 'Finalizado', 'edit': lc.status === 'Rascunho'}">
						<div class="view" v-if="lc.status === 'Enviado' || lc.status === 'Finalizado'"><i class="fas fa-eye"></i><span class="txt">visualizar</span></div>
						<div class="view" v-if="lc.status === 'Rascunho'"><i class="fas fa-edit"></i><span class="txt">editar</span></div>
					</div>
					<div class="trash" v-if="lc.status === 'Rascunho'" @click="remove(lc.id)"><i class="fas fa-trash-alt"></i><span class="txt">excluir</span></div>
				</div>
			</div>
		</div>
		<hr>
		<ModalRemove @boxDescartar="remove" @boxDelete="removeCollection" :id="id" :boxRemove="boxRemove" v-if="boxRemove" titulo="Deseja remover esta coleção ?" subTitulo="Não é possível restaurar essa ação."/>
		<Pagination :totalItens="totalItens" v-if="totalItens > 20" :currentPage="currentPage" @pagina="getFilteredCollections" :pagesQuantity="take"/>
		<CadastrarColecao @close="boxClose" @criar="createColection" v-if="close"/>
		<Load v-if="isLoad"></Load>
	</div>
</template>

<script>
import Pagination from '@/components/shared/Pagination'
import ModalRemove from '@/components/shared/ModalRemove'
import Load from '@/components/shared/Load'
import CadastrarColecao from '@/components/views/colecoes/inc/CadastrarColecao'
import EventBus from './../../event-bus'
import { colecoes } from '@/services/colecoes'
export default {
	name: 'CollectionItem',
	components: { CadastrarColecao, ModalRemove, Pagination, Load },
	data () {
		return {
			skip: 0,
			take: 20,
			nome: '',
			status: '',
			ordenarPor: '',
			ordem: 'asc',
			usuario: this.$auth.user().id,
			filteredCollections: [],
			boxCadastro: false,
			boxRemove: false,
			id: '',
			totalItens: 0,
			currentPage: 1,
			onlyRoot: true,
			isLoad: false,
			msg: '',
			close: false
		}
	},
	async created () {
		this.getFilteredCollections(this.currentPage)
	},
	watch: {
		$route: 'getFilteredCollections'
	},
	methods: {
		async createColection (dados) {
			const colecao = await colecoes.create(dados)

			if (colecao.status === 200) {
				dados = {}
				this.close = false
				this.getFilteredCollections(this.currentPage)
				window.notificationEM.open('', 'Coleção cadastrada com Sucesso !', 'success')
			} else {
				window.notificationEM.open('', `Coleção não cadastrada - Erro: ${colecao.status}`, 'error')
			}
		},
		boxClose (close) {
			this.close = close
		},
		remove (id) {
			this.boxRemove = !this.boxRemove
			this.id = id
		},
		async removeCollection (boxDelete) {
			const colecao = await colecoes.delete(this.id)
			if (colecao.status === 200) {
				this.dados = {}
				this.boxRemove = !this.boxRemove
				this.$emit('boxDelete', this.boxRemove)
				this.filteredCollections = []
				this.getFilteredCollections(this.currentPage)
				window.notificationEM.open('', 'Coleção removida com Sucesso', 'success')
			} else {
				this.loadingSubmit = false
				window.notificationEM.open('Erro !', `Coleção não foi removida! - Error: ${colecao.status}`, 'error')
			}
		},
		cadastro () {
			this.close = !this.close
		},
		async getFilteredCollections (currentPage) {
			this.isLoad = true
			this.totalItens = 0
			this.skip = parseInt(this.$route.query.skip) - 1 || this.currentPage - 1
			this.currentPage = parseInt(this.$route.query.skip) || this.currentPage

			this.filteredCollections = []

			await colecoes.obterColecaoEmArvore(this.$route.query.skip ? this.$route.query.skip - 1 : 0, this.take, this.nome, this.status, this.ordenarPor, this.ordem, this.usuario, this.onlyRoot)
				.then(res => {
					this.totalItens = res.data.length > 0 ? res.data[0].total : res.data.length
					this.filteredCollections = res.data
				})
				.catch(err => console.log(err))
			EventBus.$emit('closeLoader', false)
			this.isLoad = false

			this.msg = this.$route.params.message

			if (this.msg) {
				window.notificationEM.open('', this.msg, 'success')
			}
		},
		editCollection (id) {
			this.$router.push(`/visualizarColecao?id=${id}`)
		},
		aplicarFiltro () {
			return this.$router.push({
				name: 'minhasColecoes',
				query: { skip: 1, status: this.status }
			})
		}
	}
}
</script>

<style lang="scss" scoped>

	.box-collection {
		margin-top: 40px;

		.area_title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-family: "Roboto Condensed","Roboto",sans-serif;
			font-size: 22px;
			font-weight: bold;
			color: #fff;
			text-transform: uppercase;

			.text {
				color: #fff;
				text-transform: uppercase;
				margin-right: 20px;
			}
			.select-status {
				display: flex;
				align-items: center;

				.txt-status {
					font-size: 14px;
					margin-right: 20px;
				}
				.select {
					font-size: 16px;
					select {
						width:207px;
						padding: 1px 20px;
						font-size: 16px;
						line-height: 31px;
						color: #fff;
						background-color: #061529;
						margin: 0;
						border: 0;
						border-radius: 5px;
						appearance: none;
						cursor: pointer;

						option {
							border:0;
						}
					}

					i {
						color: #fff;
						margin-left: 10px;
						position: relative;
						left: -30px;
						pointer-events: none;
					}
				}
			}
		}
			hr {
				border: 1px solid #D1D1D1;
				width: 100%;
				opacity: 0.15;
			}
			.top_actions {
				display: flex;
				justify-content: space-between;

				button {
					width: 170px;
					padding: 10px 14px;
					border: none;
					color: #FFF;
					text-transform: uppercase;
					font-size: 15px;
					letter-spacing: .5px;
					font-family: 'Roboto Condensed', 'Roboto', sans-serif;
					font-weight: bold;
					cursor: pointer;
					margin-bottom: 20px;
					margin-top: 20px;
					background: transparent linear-gradient(74deg, #224894 0%, #00F3F3 100%) 0% 0% no-repeat padding-box;
					border-radius: 5px;

				}

				.txt-total-itens {
					display:flex;
					align-items: flex-end;
					margin-bottom: 10px;
				}
			}
			.collection {
				display: grid;
				align-items: center;
				align-content: center;
				grid-template-columns: .7fr 5fr 3fr 1fr 2fr 2fr;
				padding: 10px 20px;
				border: 2px solid #21344D;
				border-radius: 10px;
				background-color: #061529;
				color: #59708F;
				font-family: 'Roboto Condensed', 'Roboto', sans-serif;
				margin-bottom: 20px;

				a:hover, a:link, a:visited, a:active {
					text-decoration: none;
				}
				a:hover {
					opacity: 0.8;
				}

				body.light & {
					color: #FFF;
				}

				.icon {
					color: #59708F;
					margin-left: 10px;
					font-size: 30px;
				}

				.collection_name {
					margin-left: 10px;
					color: #FFFFFF;
					font-size: 20px;
					font-family: 'Roboto Condensed', 'Roboto', sans-serif;
					text-transform: uppercase;
				}

				.number {
					display: flex;
					align-items: center;
					font-weight: 700;

					.send, .final {
						display:flex;
						align-items: center;
						font-size: 20px;

						.box-number {
							display: flex;
							justify-content: center;
							background-color: #59708F;
							padding: 5px 10px;
							border-radius: 100px;
							color:#061529;
							min-width: 100px;
							margin-left: 5px;
						}

						.box-number-final {
							display: flex;
							justify-content: center;
							background-color: #061529;
							padding: 5px 10px;
							border-radius: 100px;
							color:#59708F;
							min-width: 100px;
							margin-left: 5px;
							border: 1px solid #59708F;
						}
					}
				}

				.icon-status {
					font-size: 25px;
					& .hourglass {
						color: #969D69;
					}
					& .check {
						color: #01785A;
					}

				}

				@media all and (max-width: 1600px) {
					grid-template-columns: .5fr 5fr 3fr 1fr 2fr 2fr;

					@media all and (max-width: 800px) {
						& {
							display: block;

						& .icon {
							display: inline-block;
							margin-right: 10px;
						}

						& .collection_name {
							display: inline-block;
						}
					}
				}
			}

			.last_update {
				align-items: center;

				&.env{
					color:#969D69;
				}

				&.fin{
					color:#01785A;
				}

				&.rasc{
					color: #99BCE5;
				}

				.content_title {
					display: block;
					font-size: 14px;
					text-align: center;
					margin-bottom: 10px;

					@media all and (max-width: 800px) {
						display: inline-block;
						color: unset;
						font-size: unset;
						margin-right: 10px;
					}
				}

				.content {
					display: block;
					margin-top: -5px;
					text-align: center;
					font-size: 18px;

					@media all and (max-width: 800px) {
						display: inline-block;
					}
				}
			}

			.actions {
				margin-left: auto;
				display: flex;
				align-items: center;

				@media all and (max-width: 800px) {
					margin: 10px auto 0 auto;
					text-align: center;
				}

				.button {
					font-size: 20px;
					cursor: pointer;

					&.eye {
						color: #59708F;

						.view {
							display: flex;
							align-items: center;
							padding: 9px 15px 10px;
							border: none;
							color: #59708F;
							font-size: 20px;
							border-radius: 5px;
							margin-right: 10px;
							font-family: Roboto;
							max-width: 50px;
							min-width: 50px;
							cursor: pointer;
							transition: 0.666s max-width ease;

							.txt {
								display: inline-block;
								transform: scaleX(0);
								transition: 0.444s transform ease;
								transform-origin: left center;
								margin-left: 10px;
								padding-right: 5px;
								font-size: 16px;
							}

							&:hover {
								max-width: 120px;
								color: #e2e41a;
								.txt {
									transform: scaleX(1)
								}
							}
						}
					}

					&.edit {
						color: #59708F;

						.view {
							display: flex;
							align-items: center;
							padding: 9px 15px 10px;
							border: none;
							color: #59708F;
							font-size: 20px;
							border-radius: 5px;
							margin-right: 10px;
							font-family: Roboto;
							max-width: 50px;
							min-width: 50px;
							cursor: pointer;
							transition: 0.666s max-width ease;

							.txt {
								display: inline-block;
								transform: scaleX(0);
								transition: 0.444s transform ease;
								transform-origin: left center;
								margin-left: 10px;
								padding-right: 5px;
								font-size: 16px;
							}

							&:hover {
								max-width: 100px;
								color: #FFFFFF;
								.txt {
									transform: scaleX(1)
								}
							}
						}
					}
				}
				.trash {
					font-size: 20px;
					display: flex;
					align-items: center;
					padding: 9px 15px 10px;
					border: none;
					color: #59708F;
					font-size: 20px;
					border-radius: 5px;
					margin-right: 10px;
					font-family: Roboto;
					max-width: 50px;
					min-width: 50px;
					cursor: pointer;
					transition: 0.666s max-width ease;

					.txt {
						display: inline-block;
						transform: scaleX(0);
						transition: 0.444s transform ease;
						transform-origin: left center;
						margin-left: 10px;
						padding-right: 5px;
						font-size: 16px;
					}

					&:hover {
						max-width: 100px;
						color: #d9534f;
						.txt {
							transform: scaleX(1)
						}
					}
				}
			}
		}
	}
</style>
